import type { RxJsonSchema } from 'rxdb';
import type { DeficiencyComments } from './deficiencyComments.types';

export const deficiencyCommentsSchema: RxJsonSchema<DeficiencyComments> = {
  type: 'object',
  version: 3,
  description: 'describes deficiency comments',
  primaryKey: 'pkUuid',
  properties: {
    pkUuid: { type: 'string', maxLength: 36 },
    pkDeficiencyWiseAuditComments: { type: ['number', 'null'] },
    fkAssetInspectionComponentFailure: { type: ['number', 'null'] },
    inspectorId: { type: ['number', 'null'] },
    inspectorRoleId: { type: ['number', 'null'] },
    inspectionTaskId: { type: ['number', 'null'] },
    taskStatus: { type: ['number', 'null'] },
    comment: { type: ['string', 'null'] },
    dateCreated: { type: 'string', maxLength: 36 },
    dateModified: { type: ['string', 'null'] },
    createdBy: { type: ['string', 'null'] },
    isActive: { type: ['boolean', 'null'] },
    attentionFlag: { type: ['boolean', 'null'] },
    inspectorName: { type: ['string', 'null'] },
    clerkName: { type: ['string', 'null'] },
    componentVersionId: { type: ['number', 'null'] },
    componentVersionInspectionId: { type: ['number', 'null'] },
    isVersionComment: { type: ['boolean', 'null'] },
  },
  indexes: ['dateCreated'],
};
